import React, { useState } from "react";
import "../component/css/childdetails.css";
import "../component/css/Navbar.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateFormData, submitFormData } from "../redux/actions";
import "../component/css/parentdetails.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Alert from "@mui/material/Alert";
import { sanitizeInput } from "../utils/sanitizeInput";
import { useEffect } from "react";
import countryCodeData from "./countryCode.json";
import CustomSelect from "./helpers/CustomSelect";

function Parentdetails({ Back, Forward }) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [siblings, setSiblings] = useState([
    { siblingName: "", siblingDOB: "" },
  ]);

  const handleOnChange = (value, country) => {
    setPhoneNumber(value);
    setCountryCode(country.dialCode);
  };
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.formData);
  const keywordLabels = useSelector((state) => state.keywordLabels);
  const schoolDetails = useSelector((state) => state.schoolDetails);
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const cleanedValue = sanitizeInput(value);
    dispatch(updateFormData({ [name]: cleanedValue }));
  };

  const [motherFirstName, setMotherFirstName] = useState("");
  const [validFirstMotherName, setValidFirstMotherName] = useState(true);
  const [motherLastName, setMotherLastName] = useState("");
  const [validLastMotherName, setValidLastMotherName] = useState(true)
  const [motherMobileNumber, setMotherMobileNumber] = useState("");
  const [validMotherMobileNumber, setValidMotherMobileNumber] = useState(true);
  const [motherEmail, setMotherEmail] = useState("");
  const [validMotherEmail, setValidMotherEmail] = useState(true);
  const [fatherFirstName, setFatherFirstName] = useState("");
  const [validFatherFirstName, setValidFatherFirstName] = useState(true);
  const [fatherLastName, setFatherLastName] = useState("");
  const [validFatherLastName, setValidFatherLastName] = useState(true);
  const [fatherMobileNumber, setFatherMobileNumber] = useState("");
  const [validFatherMobileNumber, setValidFatherMobileNumber] = useState(true);
  const [fatherEmail, setFatherEmail] = useState("");
  const [validFatherEmail, setValidFatherEmail] = useState(true);
  const [errors, setErrors] = useState({});
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [err, setErrs] = useState("");
  const [parentFirstName, setParentFirstName] = useState("");
  const [validFirstParentName, setValidFirstParentName] = useState(true);
  const [parentLastName, setParentLastName] = useState("");
  const [validLastParentName, setValidLastParentName] = useState(true)
  const [parentMobileNumber, setParentMobileNumber] = useState("");
  const [validParentMobileNumber, setValidParentMobileNumber] = useState(true);
  const [parentEmail, setParentEmail] = useState("");
  const [validParentEmail, setValidParentEmail] = useState(true);

  const [validSubmittedBy, setIsSubmittedBy] = useState(true);


  const handleSubmittedByBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setIsSubmittedBy(false)
      setValidationErrors("Please select who is submitting the form.");
    }
    else {
      setIsSubmittedBy(true)
      setErrs('')

    }
  };

  const setValidationErrors = (err) => {
    setErrs(err);
  };
  const handleNext = () => {

    const emailRegex = /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const mobileRegex = /^\+?[1-9]\d{1,14}$/;


    switch (true) {
      case !formData?.submittedBy:
        return setValidationErrors("You must select who is submitting the enrollment form.");

      case !formData?.parentFirstName:
        return setValidationErrors("You must provide parent's first name.");

      case !formData?.parentLastName:
        return setValidationErrors("You must provide parent's last name.");

      case !formData?.parentMobile || !mobileRegex.test(formData?.parentMobile?.length):
        return setValidationErrors("You must provide valid parent's contact number.");

      case !formData?.parentEmail || !emailRegex.test(formData?.parentEmail):
        return setValidationErrors("You must provide valid parent's email.");


        Forward();

    }

    Forward();
  };
  const mobileRegex = /^\+?[1-9]\d{1,14}$/;
  const emailRegex = /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;



  const handleParentFirstNameBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setValidFirstParentName(false)
      setValidationErrors("Please provide parent's first name.");
    } else {
      setValidFirstParentName(true)
      setErrs('')

    }
  };
  const handleParentLastNameBlur = (e) => {
    const inputValue = e.target.value;
    if (inputValue.trim() === "") {
      setValidLastParentName(false)
      setValidationErrors("Please provide parent's last name.");
    } else {
      setValidLastParentName(true)
      setErrs('')
    }
  };

  const handleParentMobileNumberBlur = (e) => {
    const inputValue = e.target.value;
    if (!mobileRegex.test(formData?.parentMobile?.length)) {
      setValidParentMobileNumber(false)
      setValidationErrors("Please provide parent's mobile number.");
    } else {
      setValidParentMobileNumber(true)
      setErrs('')

    }
  };

  const handleParentEmailBlur = (e) => {
    const inputValue = e.target.value;
    if (!emailRegex.test(formData?.parentEmail)) {
      setValidParentEmail(false)
      setValidationErrors("Please provide parent's email address.");
    } else {
      setValidParentEmail(true)
      setErrs('')
    }
  };

  useEffect(() => {
    if (formData) {
      const { siblings: formSib } = formData;
      if (Array.isArray(formSib)) {
        setSiblings(formSib);
      } else if (typeof formSib === "string") {
        setSiblings(JSON.parse(formSib));
      }
    }
  }, []);

  // Get default country code from school details
  const getDefaultCountry = () => {
    if (schoolDetails?.addresses?.country) {
      const countryInfo = countryCodeData.find(
        (c) => c.country.toLowerCase() === schoolDetails.addresses.country.toLowerCase()
      );
      return countryInfo ? countryInfo.iso.toLowerCase() : 'in';
    }
    return 'in'; // Default to India
  };
  return (
    <section className="child-main-sec">
      <div className="main-sec">

        <div className="main-head">
          <h1 className="font-fmly font-fml">
            <span>{keywordLabels?.orgName || "Sparkle"}</span> {keywordLabels?.child || "Child"} Admission Form
          </h1>
          <span>{formData?.applicationId}</span>
        </div>

        <div className="head-sec">
          <div className="para-sec">
            <h3>Add Parent Details</h3>

          </div>
        </div>
        <div style={{ minHeight: '20px' }}> {/* adjust height as needed */}
          {err.length !== 0 ? (
            <Alert severity="error" className="arror-find">
              {err}
            </Alert>
          ) : null}
        </div>

        <div className="input-main  pdg">
          <div className="inp-tell-1 inp-tell">
            <label className="my-label">Form Submitted By*</label>
            <CustomSelect
              name="submittedBy"
              className="input"
              value={formData?.submittedBy}
              style={validSubmittedBy ? {} : { border: '1px solid red' }}

              onChange={(e) => {
                handleInputChange(e);
              }}
              onBlur={(e) => {
                handleSubmittedByBlur(e);
              }}
            >
              <option disabled selected>
                <span id="span"> </span>
              </option>
              <option value={"Mother"}>Mother</option>
              <option value={"Father"}>Father</option>
              <option value={"Other"}>Other</option>
            </CustomSelect>
          </div>
        </div>








        <div className="input-main pdg">
          <div className="inp-tell-1 inp-tell">
            <label className="my-label">Parent First Name*</label>
            <input
              type="text"
              name="parentFirstName"
              style={validFirstParentName ? {} : { border: '1px solid red' }}
              value={formData?.parentFirstName}
              onChange={(e) => {
                handleInputChange(e);
              }}
              onBlur={(e) => {
                handleParentFirstNameBlur(e);
              }}
              className="input input-padding"
            />
          </div>
          <div className="inp-tell-1 inp-tell left">
            <label className="my-label">Parent Last Name*</label>
            <input
              name="parentLastName"
              type="text"
              value={formData?.parentLastName}
              style={validLastParentName ? {} : { border: '1px solid red' }}
              onChange={(e) => {
                handleInputChange(e);
              }}
              onBlur={(e) => {
                handleParentLastNameBlur(e);
              }}
              className="input input-padding"
            />
          </div>
        </div>

        <div className="input-main pdg">
          <div className="inp-tell-1 inp-tell">
            <label className="my-label">Parent Mobile Number*</label>
            <PhoneInput
              className="inputt main-inp-m-f"
              type="number"
              name="parentMobile"
              country={getDefaultCountry()}
              value={formData?.parentMobile}
              style={validParentMobileNumber ? {} : { border: '1px solid red' }}
              onChange={(e) => {
                console.log(e);
                const event = {};
                event.target = {
                  value: e,
                  name: "parentMobile",
                };
                handleInputChange(event);
              }}
              onBlur={(e) => {
                handleParentMobileNumberBlur(e);
              }}
            />
          </div>
          <div className="inp-tell-1 inp-tell left">
            <label className="my-label">Parent Email Address*</label>
            <input
              type="email"
              name="parentEmail"
              value={formData?.parentEmail}
              style={validParentEmail ? {} : { border: '1px solid red' }}
              onChange={(e) => {
                handleInputChange(e);
              }}
              onBlur={(e) => {
                handleParentEmailBlur(e);
              }}
              className="input input-padding"
            />
          </div>
        </div>

        <div className="form-footer">

          <div className="btn-left">
            <button className="button pdg back" onClick={Back}>
              Back
            </button>
          </div>

          <div className="btn-right">
            <button className="button pdg continue" onClick={handleNext}>
              Continue
            </button>
          </div>
        </div>
      </div>
    </section>


  );
}

export default Parentdetails;
